export const PROGRAM_IDS = {
  // LAS
  LAS_CA: "M7X8T953BKVSG",
  LAS_CHUB: "LNA4FTCKB004M",
  LAS_CSM: "LQGK18YODQ6D2",
  LAS_MTS: "LNA4FTCKB003M",
  LAS_NQP: "M9BG7MD6N63H0",
  // NEAS
  NEAS_EPRR: "M47YSAO1MFX4B",
  NEAS_NQP: "M167IR37RNSSQ",
  // NWAS
  NWAS_EPRR: "LR0HYZYWY6JQK",
  NWAS_ARC: "MB81RFIVJPE1N",
  NWAS_NQP: "LZCUV68I1O975",
  // SWAST
  SWAST_HART: "LNA4FTCKB002M",
  SWAST_HART_EPRR: "LNLT7JSYDT5PJ",
  SWAST_PRECEPTORSHIP: "LNA4FTCKB012M",
  SWAST_NQP2: "LNA4FTCKB005M",
  SWAST_SP_AP_RP: "MB80U7V2XXYQQ",
  // YAS
  YAS_NQP: "M7EPWBZE8P2XK",
  // TEST PROGRAM
  TEST_PROGRAM: "M7N9K0Y7IOUMI",
};
